// @flow
import React, { Component } from 'react';



import RoofHome from '../RoofHome';
import NewHome from '../NewHome';
import LandingPage from '../LandingPage';
import Foundation from '../Foundation';
import { NavHashLink as NavLink } from "react-router-hash-link";
import SamplePopup from '../SamplePopup';

import LazyLoad from 'react-lazyload';

import './Home.scss';

export default class Home extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeSection: "",
      popupForm: false,
    }


  }
  scrollWithOffset = (el, offset) => {
    const elementPosition = el.offsetTop - offset;
    if (typeof window !== "undefined") {
      window.scroll({
        top: elementPosition,
        left: 0,
        behavior: "smooth"
      });
    }
  };

  handleScroll = e => {
    let element = e.target
    console.log("element.scrollHeight - element.scrollTop")
    console.log(element.scrollHeight - element.scrollTop)
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      this.setState({ popupForm: true });
     
    }
  }


  openPopupForm = () => {
    this.setState({ popupForm: true });
  }

  closePopupForm = () => {
    this.setState({ popupForm: false });
  }


  render() {

    const ssr = (typeof this.props.ssr !== undefined && this.props.ssr) ? true : false;
    return (
      <div className="roof-body" >
        {/* <button onClick={this.openPopupForm}
          className="home__popup-button">Odbierz darmową próbkę</button> */}

        {/* {this.state.popupForm ?
          <SamplePopup closePopupForm={this.closePopupForm} />
          : null} */}

        <NewHome  />
       {/*  <LandingPage smoothScroll={this.scrollWithOffset.bind(this)} activeSection={this.state.activeSection} />
        <Foundation /> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home/Home.js